import axios from "@/axios"

export function getFlocks() {
  return axios.get(`${process.env.NEXT_PUBLIC_REACT_APP_API}/flocks`)
}
